<template>
    <div>
        <base-header class="pb-8 pt-4">
            <!-- Card stats -->
            <div class="row invoice-card-row">
                <div class="col-xl-6 col-xxl-6 col-sm-12">
                    <div class="card bg-success invoice-card">
                        <div class="card-body d-flex">
                            <div class="icon mr-3">
                                <i class="fas fa-chart-bar text-white mt-2"></i>
                            </div>
                            <div>
                                <h2 class="text-white invoice-num">{{ formatCurrency(income) }} TL</h2>
                                <span class="text-white fs-18">{{ dailyWeekMonth }} Gelir</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6 col-xxl-6 col-sm-12 mt-md-0 mt-2">
                    <div class="card bg-warning invoice-card">
                        <div class="card-body d-flex">
                            <div class="icon mr-3">
                                <i class="ni ni-diamond text-white mt-2"></i>
                            </div>
                            <div>
                                <h2 class="text-white invoice-num">{{ formatCurrency(expense) }} TL</h2>
                                <span class="text-white fs-18">{{ dailyWeekMonth }} Gider</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </base-header>


        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-12 mb-4">
                    <b-card-header>
                        <div class="align-items-center row">
                            <div class="col d-flex flex-column align-items-star">
                                <h3 class="card-title mb-0">Gelir Gider</h3>
                                <div class="d-flex mt-2">
                                    <div class="text-sm " style="width:200px;">
                                        <b-form-group class="mb-0">
                                            <b-form-select v-model="company" :options="users" />
                                        </b-form-group>
                                    </div>
                                    <div class="text-sm ml-4" style="width:200px;">
                                        <b-form-group class="mb-0">
                                            <b-form-select v-model="filterType" :options="[
                                                { text: 'Tüm Zamanlar', value: '' },
                                                { text: 'Bugün', value: 'daily' },
                                                { text: 'Bu hafta', value: 'weekly' },
                                                { text: 'Bu ay', value: 'monthly' },
                                                { text: 'Tarih seç', value: 'other' },
                                            ]" />
                                        </b-form-group>
                                    </div>
                                    <template v-if="filterType === 'other'">
                                        <div class="text-sm ml-4" style="width:200px;">
                                            <b-form-group class="mb-0">
                                                <b-form-input type="date" v-model="startDate" />
                                            </b-form-group>
                                        </div>
                                        <div class="text-sm ml-4" style="width:200px;">
                                            <b-form-group class="mb-0">
                                                <b-form-input type="date" v-model="endDate" />
                                            </b-form-group>
                                        </div>
                                    </template>
                                    <div class="text-sm ml-4" style="width:200px;">
                                        <b-button variant="primary" @click="refreshTables()">{{ $t('Güncelle')
                                        }}</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right mt-3">
                            <b-button @click="
                                service = { tax: 0, used_time: 0 };
                            $refs.modal.show();
                            " class="btn-sm" variant="primary">+ Yeni İşlem Ekle
                            </b-button>
                        </div>
                    </b-card-header>
                </div>
                <b-modal ref="modal" title="Yeni İşlem" @hide="resetModal">


                    <b-col xs="12" md="12" class="px-0">
                        <b-form-group label="İşlem Tipi">
                            <b-form-select required v-model="newReport.type">
                                <b-form-select-option value="income">Gelir</b-form-select-option>
                                <b-form-select-option value="expense">Gider</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-row>
                        <b-col>
                            <b-form-group label="Kategori">
                                <b-form-input required v-model="newReport.category" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-col xs="12" md="12" class="px-0">
                        <b-form-group label="Ödeme Tipi">
                            <b-form-select required v-model="newReport.payment_type">
                                <b-form-select-option value="cash">Nakit</b-form-select-option>
                                <b-form-select-option value="card">Kredi Kartı</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-row>
                        <b-col>
                            <b-form-group label="Tarih">
                                <b-form-input required v-model="newReport.date" type="datetime-local"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group label="Ücret">
                                <b-form-input required v-model="newReport.price" type="number"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <template v-slot:modal-footer>
                        <b-button variant="primary" @click="submitModal">{{ $t('Kaydet') }}
                        </b-button>
                    </template>
                </b-modal>
                <div class="col-xl-6 col-12">
                    <b-card no-body class="h-100">
                        <b-card-header>
                            <div class="align-items-center row">
                                <div class="col d-flex align-items-center">
                                    <h3 class="card-title mb-0">Giderler</h3>
                                </div>
                            </div>
                        </b-card-header>

                        <div class="table-container">
                            <b-table ref="table2" class="align-items-center" thead-class="thead-light"
                                :fields="getFields2" :items="items2" show-empty>

                                <template v-slot:empty>
                                    <div class="text-center">
                                        {{ $t('Henüz hiçbir kayıt bulunmamakta.') }}!
                                    </div>
                                </template>
                                <template v-slot:cell(sira)="data">
                                    <div class="text-center">
                                        {{ giderLength - data.index }}
                                    </div>
                                </template>
                                <template v-slot:cell(price)="data">
                                    <div class="text-center">
                                        {{ formatCurrency(data.item.price) }}
                                    </div>
                                </template>
                                <template v-slot:cell(date)="data">
                                    <div class="text-center">
                                        {{ moment(data.item.date).format('HH:mm DD-MM-YYYY') }}
                                    </div>
                                </template>

                                <template v-slot:table-busy>
                                    <div style="width: 100%; text-align:center;">
                                        <b-spinner label="Spinning"></b-spinner>
                                    </div>
                                </template>

                                <template v-slot:cell(title)="data">
                                    <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t('GELİR')
                                    }}</b-badge>
                                    <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t('GİDER')
                                    }}</b-badge>
                                </template>

                                <template v-slot:cell(payment_type)="data">
                                    <div v-if="data.item.payment_type === 'cash'">Nakit</div>
                                    <div v-else-if="data.item.payment_type === 'card'">Kart</div>
                                </template>

                                <template v-slot:cell(actions)="data">
                                    <b-button variant="warning" size="sm" v-if="getType != 'all'"
                                        @click="showAccounting(data.item)">{{
                                            $t('Görüntüle') }}</b-button>
                                    <b-button variant="danger" size="sm" v-if="getType != 'all'"
                                        @click="deleteAccountingAction(data.item.id)">Sil</b-button>
                                </template>

                            </b-table>
                        </div>
                        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3"
                            v-if="pagination.totalRows > 9">
                            <b-pagination @change="changepagination" v-model="pagination.currentPage"
                                :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
                        </div>

                    </b-card>
                </div>
                <div class="col-xl-6 col-12">
                    <b-card no-body class="h-100">
                        <b-card-header>
                            <div class="align-items-center row">
                                <div class="col d-flex align-items-center">
                                    <h3 class="card-title mb-0">Gelirler</h3>
                                </div>
                            </div>
                        </b-card-header>

                        <div class="table-container">
                            <b-table ref="table1" class="align-items-center" thead-class="thead-light"
                                :fields="getFields" :items="items" show-empty>

                                <template v-slot:empty>
                                    <div class="text-center">
                                        {{ $t('Henüz hiçbir kayıt bulunmamakta.') }}!
                                    </div>
                                </template>
                                <template v-slot:cell(sira)="data">
                                    <div class="text-center">
                                        {{ gelirLength - data.index }}
                                    </div>
                                </template>
                                <template v-slot:cell(price)="data">
                                    <div class="text-center">
                                        {{ formatCurrency(data.item.price) }}
                                    </div>
                                </template>
                                <template v-slot:cell(date)="data">
                                    <div class="text-center">
                                        {{ moment(data.item.date).format('HH:mm DD-MM-YYYY') }}
                                    </div>
                                </template>

                                <template v-slot:table-busy>
                                    <div style="width: 100%; text-align:center;">
                                        <b-spinner label="Spinning"></b-spinner>
                                    </div>
                                </template>

                                <template v-slot:cell(title)="data">
                                    <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t('GELİR')
                                    }}</b-badge>
                                    <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t('GİDER')
                                    }}</b-badge>
                                </template>

                                <template v-slot:cell(payment_type)="data">
                                    <div v-if="data.item.payment_type === 'cash'">Nakit</div>
                                    <div v-else-if="data.item.payment_type === 'card'">Kart</div>
                                </template>

                                <template v-slot:cell(actions)="data">
                                    <b-button variant="warning" size="sm" v-if="getType != 'all'"
                                        @click="showAccounting(data.item)">{{
                                            $t('Görüntüle') }}</b-button>
                                    <b-button variant="danger" size="sm" v-if="getType != 'all'"
                                        @click="deleteAccountingAction(data.item.id)">Sil</b-button>
                                </template>

                            </b-table>
                        </div>

                        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3"
                            v-if="pagination2.totalRows > 9">
                            <b-pagination @change="changepagination2" v-model="pagination2.currentPage"
                                :total-rows="pagination2.totalRows" :per-page="pagination2.perPage" />
                        </div>
                    </b-card>
                </div>

            </div>

        </div>

        <!-- Credit to Income -->
        <b-modal ref="dateModal" @hide="resetDateModal">
            <b-form-group :label="$t('Ödeme Tarihi')">
                <b-form-input v-model="dateModal.date" type="date" />
            </b-form-group>
            <template v-if="dateModal.type !== 'one_time'">
                <b-form-group :label="$t('Sonraki Fatura Tarihi')">
                    <b-form-input v-model="dateModal.new_first_payment_date" type="date" />
                </b-form-group>
                <b-form-group :label="$t('Sonraki Vade')">
                    <b-form-input v-model="dateModal.new_last_payment_date" type="date" />
                </b-form-group>
            </template>
            <template v-slot:modal-footer>
                <b-button @click="$refs.dateModal.hide()">{{ $t("Vazgeç") }}</b-button>
                <b-button @click="changeToIncome" variant="primary">{{ $t("Gelire Dönüştür") }}</b-button>
            </template>
        </b-modal>
        <!--#Credit to Income -->

        <!-- Debt to Expense -->
        <change-accounting-type :show="showChangeModal" :id="dateModal.id" to="expense" @hide="resetChangeModal()"
            @refresh-table="refreshTable()" />
        <!--#Debt to Expense -->

        <b-modal ref="accountingModal" :title="$t('İşlem Detayları')">
            <b-table :fields="[
                { key: 'sira', label: '' },
                { key: 'service.name', label: 'Ürün' },
                { key: 'price', label: 'Fiyat' }
            ]" :items="accounting_services" bordered>
                <template v-slot:cell(sira)="data">
                    <div class="text-center">
                        {{ data.index + 1 }}
                    </div>
                </template>
                <template v-slot:cell(price)="data">
                    <div class="">{{ formatCurrency(data.item.price) }} TL</div>
                </template>
            </b-table>
            <template v-slot:modal-footer>
                <b-button @click="$refs.accountingModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
            </template>
        </b-modal>
        <b-modal ref="storageModal" :title="$t('İşlem Detayları')">
            <b-table :fields="[
                { key: 'category', label: 'Kategori' },
                { key: 'amount', label: 'Miktar' },
                { key: 'price', label: 'Fiyat' },
            ]" :items="accounting_services" bordered>
                <template v-slot:cell(sira)="data">
                    <div class="text-center">
                        {{ data.index + 1 }}
                    </div>
                </template>
                <template v-slot:cell(price)="data">
                    <div class="">{{ formatCurrency(data.item.price) }} TL</div>
                </template>
            </b-table>
            <template v-slot:modal-footer>
                <b-button @click="$refs.storageModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
            </template>
        </b-modal>
    </div>

</template>

<script>
import ChangeAccountingType from "../../components/modal/ChangeAccountingType";
import { mapActions } from 'vuex';
import moment from "moment";
import { TimeScale } from "chart.js";

export default {
    components: { ChangeAccountingType },
    data() {
        return {
            dailyWeekMonth: "Toplam",
            accounting: {},
            filterType: 'daily',
            startDate: '',
            endDate: '',
            total: 1,
            income: '0',
            expense: '0',
            credit: '0',
            debt: '0',
            giderLength: 0,
            gelirLength: 0,
            company: null,
            currentPage: 1,
            perPage: 15,
            dateModal: {},
            showChangeModal: false,
            accounting_services: [],
            user: {},
            users: [],
            gelir: [],
            gider: [],
            pagination: {
                currentPage: 1,
                totalRows: 1,
                perPage: 10,
            },
            pagination2: {
                currentPage: 1,
                totalRows: 1,
                perPage: 10,
            },
            company: null,
            newReport: {
                type: 'income',
                category: '',
                date: '',
                price: '',
                payment_type: 'cash',
            },
            submitType: 'create',
        }
    },
    computed: {
        getType() {
            return this.$route.params.type
        },
        getFields() {
            let arr = [
                { key: 'category', label: 'Kategori' },
                { key: 'price', label: 'Ücret' },
                { key: 'date', label: 'Ödeme Tarihi' },
                { key: 'payment_type', label: 'Ödeme Şekli' },
                { key: 'user.name', label: 'Bayi' },
            ];
            arr.push({ key: 'actions', label: '', tdClass: 'text-right' })
            return arr
        },
        getFields2() {
            let arr = [
                { key: 'category', label: 'Kategori' },
                { key: 'price', label: 'Ücret' },
                { key: 'date', label: 'Ödeme Tarihi' },
                { key: 'payment_type', label: 'Ödeme Şekli' },
                { key: 'user.name', label: 'Bayi' },
            ];
            arr.push({ key: 'actions', label: '', tdClass: 'text-right' })
            return arr
        },

    },
    methods: {
        ...mapActions(['getAdminAccountings', 'changeCreditToIncome', 'deleteAccounting', 'getUser', 'createReport', 'updateReport', 'allUsers', 'getAccountingServices']),
        formatCurrency(value) {
            return new Intl.NumberFormat('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        showAccounting(data) {
            return this.getAccountingServices({ 'id': data.id, 'company': data.company_id }).then(data => data.data).then(response => {
                let $services = [];
                if (response.sale.length > 0) {
                    $services = response.sale;
                    this.$refs.accountingModal.show();
                } else {
                    $services = [response.storage];
                    this.$refs.storageModal.show();
                }
                this.accounting_services = $services;
                return this.accounting_services;
            }).catch(error => {
                this.error(error.response.data.message);
            })
        },
        moment,
        deleteAccountingAction(id) {
            this.$swal({
                icon: 'warning',
                title: 'Dikkat',
                text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
            }).then(ok => {
                if (ok.value) {
                    this.deleteAccounting(id).then(res => {
                        this.success(res.data.message);
                        this.refreshTables();
                    }).catch(error => {
                        this.error(error.response.data.message);
                    });
                }
            });
        },
        resetAndHideModal() {
            this.resetModal();
            this.hideModal();
        },
        openModal() {
            this.$refs.modal.show();
        },
        hideModal() {
            this.$refs.modal.hide();
        },
        resetModal() {

            this.submitType = 'create';
            this.newReport = {
                type: 'income',
                category: '',
                date: '',
                price: '',
                payment_type: 'cash',
            };
        },
        resetChangeModal() {
            this.dateModal = { id: '' };
            this.showChangeModal = false;
        },
        openToExpenseModal(id) {
            this.dateModal = { id: id };
            this.showChangeModal = true;
        },
        changeToIncome() {
            this.changeCreditToIncome({
                id: this.dateModal.id,
                date: this.dateModal.date,
                new_first_payment_date: this.dateModal.new_first_payment_date,
                new_last_payment_date: this.dateModal.new_last_payment_date,
            }).then(res => {
                this.success(res.data.message);
                this.$refs.dateModal.hide();
                this.refreshTable();
            }).catch(error => {
                this.error(error.response.data.message);
            });
        },
        resetDateModal() {
            this.dateModal = {
                id: '',
                type: 'one_time',
                date: moment().format('YYYY-MM-DD'),
                new_first_payment_date: null,
                new_last_payment_date: null,
            };
        },
        changepagination(e) {
            this.$refs.table2.refresh();
        },
        changepagination2(e) {
            this.$refs.table1.refresh();
        },
        openTypeModal(data) {
            this.dateModal.id = data.id;
            this.dateModal.type = data.type_of_payment;
            if (data.type_of_payment === 'monthly') {
                this.dateModal.new_first_payment_date = moment(data.first_payment_date).add(1, 'M').format('YYYY-MM-DD');
                this.dateModal.new_last_payment_date = moment(data.last_payment_date).add(1, 'M').format('YYYY-MM-DD');
            } else if (data.type_of_payment === 'yearly') {
                this.dateModal.new_first_payment_date = moment(data.first_payment_date).add(1, 'Y').format('YYYY-MM-DD');
                this.dateModal.new_last_payment_date = moment(data.last_payment_date).add(1, 'Y').format('YYYY-MM-DD');
            }
            this.$refs.dateModal.show();
        },
        refreshTable() {
            this.$refs.table.refresh();
        },
        paymentType(type) {
            switch (type) {
                case 'credit_cart':
                    return 'Kredi Kartı';
                case 'eft':
                    return 'Havale / EFT';
                case 'check':
                    return 'Çek';
                case 'bill':
                    return 'Senet';
                default:
                    return 'Nakit';
            }
        },
        getUsers() {
            this.allUsers().then(data => data.data).then(response => {
                this.users = [
                    { text: 'Tümü', value: null },
                    ...response.users.map(user => ({
                        text: user.name,
                        value: user.id
                    }))
                ];
            })
        },
        submitModal() {
            if (this.submitType === 'update') {
                this.updateReport({
                    id: this.id,
                    newReport: this.newReport,
                })
                    .then((response) => {
                        this.success(response.data.message);
                        this.hideModal();
                        this.refreshTable();
                    })
                    .catch((error) => {
                        this.format(error.response.data.errors).forEach((item) => {
                            this.error(item);
                        });
                    });
            } else {
                this.createReport(this.newReport)
                    .then((response) => {
                        this.success(response.data.message);
                        this.hideModal();
                        this.refreshTable();
                    })
                    .catch((error) => {
                        this.format(error.response.data.errors).forEach((item) => {
                            this.error(item);
                        });
                    });
            }
        },
        editService(service) {
            this.submitType = 'update';
            const item = JSON.parse(JSON.stringify(service));
            this.id = item.id;
            this.newReport = item;
            this.openModal();
        },
        items() {
            const parameters = this.parameters();
            return this.getAdminAccountings(parameters).then(data => data.data).then(response => {
                this.income = response.income;
                this.expense = response.expense;

                if (parameters.type == 'weekly') {
                    this.dailyWeekMonth = 'Haftalık';
                } else if (parameters.type === 'monthly') {
                    this.dailyWeekMonth = 'Aylık';
                } else if (parameters.type === 'daily') {
                    this.dailyWeekMonth = 'Günlük';
                } else {
                    this.dailyWeekMonth = 'Toplam';
                }

                const gelir = response.gelir;
                this.gelir = gelir;
                this.gelirLength = response.giderTotal;

                this.pagination.totalRows = response.giderTotal;
                this.pagination2.totalRows = response.gelirTotal;
                return gelir;
            }).catch(error => {
                this.error(error.response.data.message);
            })
        },
        items2() {
            const parameters = this.parameters();
            return this.getAdminAccountings(parameters).then(data => data.data).then(response => {

                const gider = response.gider;
                this.gider = gider;
                this.giderLength = response.gelirTotal;
                this.pagination.totalRows = response.giderTotal;
                this.pagination2.totalRows = response.gelirTotal;
                return gider;
            }).catch(error => {
                this.error(error.response.data.message);
            })
        },
        parameters() {
            const params = {};
            params.type = this.filterType;
            params.company = this.company
            if (this.company != null) {
                params.company = this.company
            }
            if (params.type === 'other') {
                params.start_date = this.startDate;
                params.end_date = this.endDate;
            }

            params.page = this.pagination.currentPage;
            params.page2 = this.pagination2.currentPage;
            params.per_page = this.pagination.perPage;

            return params;
        },

        refreshTables() {
            if (this.$refs.table1) {
                this.$refs.table1.refresh();
            }
            if (this.$refs.table2) {
                this.$refs.table2.refresh();
            }

            this.items();
            this.items2();
        }
    },
    mounted() {
        this.getUsers();
    }
}
</script>

<style>
.b-table-wrapper {
    overflow-x: auto;
}
</style>